import withFormControl from '@shared/lib/form/withFormControl';
import RadioGroupField from '@ui/RadioGroupField';
import CheckboxField from './CheckboxField';
import CountryAutocomplete from './CountryAutocomplete';
import DateField from './DateField';
import NewPasswordField from './NewPasswordField';
import OneTimeCodeField from './OneTimeCodeField';
import PhoneNumberField from './PhoneNumberField';
import TextFormField from './TextFormField';

export const FormTextField = withFormControl(TextFormField);
export const FormDateField = withFormControl(DateField);
export const FormCountryField = withFormControl(CountryAutocomplete);
export const FormRadioField = withFormControl(RadioGroupField);
export const FormCheckboxField = withFormControl(CheckboxField);
export const FormPhoneField = withFormControl(PhoneNumberField);
export const FormOneTimeCodeField = withFormControl(OneTimeCodeField);
export const FormPasswordField = withFormControl(NewPasswordField);
